// store/slices/UserSlice.ts
import { STORAGE } from '../../_config';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  isAuthenticated: boolean;
  token: string | null;
  email: string | null;
  expires_at: any | null;
  user: any | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  token: null,
  email: null,
  expires_at: null,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(
      state,
      action: PayloadAction<{ token: string; email: string; expires_at: any }>,
    ) {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.email = action.payload.email;
      state.expires_at = action.payload.expires_at;
    },
    updateUser(state, action: PayloadAction<{ user: any }>) {
      state.user = action.payload.user;
    },
    logout(state) {
      localStorage.removeItem(STORAGE);
      state.isAuthenticated = false;
      state.token = null;
      state.email = null;
      state.expires_at = null;
      state.user = null;
    },
  },
});

export const { login, updateUser, logout } = authSlice.actions;
export default authSlice.reducer;
